import {Image} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher.js";

export class PanelImage extends Image {
    onMount() {
        this.addLoadListener(() => Dispatcher.Global.dispatch("iframeSizeChange"));
    }
}
